import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import ReviewSummary from 'marketplace-ui-reviews/records/ReviewSummary';
import { cleanObject } from 'marketplace-ui-common/utils/formatters';
import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
const defaults = {
  companyName: '',
  exampleUrl: '',
  featureHeadlines: [],
  installsCount: 0,
  name: '',
  offeringId: 0,
  priceCents: 0,
  providerName: '',
  reviewSummary: {},
  slug: '',
  thumbnailUrl: ''
};
export default class AssetCardResult extends createImmutableObjectClass(defaults, {
  fromJSON: (_ref) => {
    let {
      reviewSummary
    } = _ref,
        rest = _objectWithoutPropertiesLoose(_ref, ["reviewSummary"]);

    return cleanObject(Object.assign({
      reviewSummary: new ReviewSummary(reviewSummary)
    }, rest));
  },
  toJSON: (_ref2) => {
    let {
      reviewSummary
    } = _ref2,
        rest = _objectWithoutPropertiesLoose(_ref2, ["reviewSummary"]);

    return Object.assign({
      reviewSummary: reviewSummary.toJSON()
    }, rest);
  }
}) {}